import { ServiceRequestRepository } from './ServiceRequestRepository'
import ServiceRequestModel from './ServiceRequestModel'
import { JtechStore } from 'src/plugins/mobx'
import router from 'src/router'

export default class ServiceRequestController {
  state = ServiceRequestModel.getInstance();
  indexVue = undefined;
  menu = '{}'

  routerStore = {
    name: undefined,
    params: undefined
  }

  static getInstance () {
    return JtechStore.getSingleton('ServiceRequestController', new ServiceRequestController())
  }

  setIndexVue (indexVue) {
    this.indexVue = indexVue
  }

  async start () {
    await this.loadMenu()
    if (this.routerStore.name && this.routerStore.name != 'serviceRequest.start') {
      router.push(this.routerStore)
      return
    }
    if (!this.routerStore.name) {
      const { serviceRequests } = await this.loadNotFinish()
      if (serviceRequests) {
        await serviceRequests.forEach(async row => {
          this.state.setServiceRequest(row.id, {
            ...row
          })
        })
      }
    }
    return await ServiceRequestRepository.start()
  }

  async loadNotFinish () {
    return await ServiceRequestRepository.loadNotFinish({})
  }

  async create (parans) {
    const { id } = await ServiceRequestRepository.create(parans)
    await this.loadProtocol(id)
    await this.load(id, this.state.serviceRequests[id])
    this.router({
      name: 'serviceRequest.list',
      params: { protocol: id }
    })
  }

  async loadProtocol (protocol) {
    const dadosForm = await ServiceRequestRepository.model({
      id: protocol
    })
    this.state.setServiceRequest(protocol, {
      ...dadosForm,
      id: protocol
    })
  }

  async load (protocol, dadosForm, params = {}) {
    const { consumerUnits } = await ServiceRequestRepository.list({
      id: protocol, ...params
    })
    const cus = {};
    (consumerUnits || []).forEach(cu => { cus[cu.id] = { ...cu, router: undefined, infoCad: { name: 'carlos' }, menu: JSON.parse(this.menu) } })
    this.state.setServiceRequest(protocol, {
      ...dadosForm,
      consumerUnits: cus
    })
  }

  async searchClient (parans) {
    return await ServiceRequestRepository.searchClient(parans)
  }

  async modelForm (id) {
    return await ServiceRequestRepository.modelForm(
      {
        id: id
      }
    )
  }

  async listForm (id) {
    return await ServiceRequestRepository.listForm(
      {
        id: id
      }
    )
  }

  async finishBegin ({ protocol }) {
    await this.indexVue.showModalFinish({ protocol })
  }

  async finishEnd ({ message, protocol }) {
    const data = await ServiceRequestRepository.finish({
      id: protocol,
      message
    })
    if (data.result == 'success') {
      this.indexVue.closeModalFinish()
      this.router({
        name: 'serviceRequest.start'
      })
      this.state.removeServiceRequest(protocol)
    }
  }

  async loadMenu () {
    const menu = {}
    let active = true
    const menuItens = await ServiceRequestRepository.getMenu()
    Object.keys(menuItens).forEach(key => {
      menuItens[key][0].active = active
      menu[key] = { key, active, icon: menuItens[key][0].nmImagemIconeGrupo, idGrupoPontoAcesso: menuItens[key][0].idGrupoPontoAcesso, label: menuItens[key][0].dsGrupoPontoAcesso, list: menuItens[key] }
      active = false
    })
    this.menu = JSON.stringify(menu)
  }

  async getInfoCard (protocol, consumerUnit) {
    const { form, model } = await ServiceRequestRepository.getInfoCard({ id: consumerUnit })
    const infoCard = {}
    form[0].inputs.forEach(input => {
      infoCard[input.name] = { ...input, value: model.dadosForm[input.name] }
    })
    infoCard.address = model.relacionamentos.address
    this.state.serviceRequests[protocol].consumerUnits[consumerUnit].infoCad = infoCard
  }

  router (params) {
    if (router.currentRoute.name != params.name || router.currentRoute?.params?.protocol != params?.params?.protocol) {
      this.routerStore = params
      router.push(params)
    }
  }

  async loadHistoryForm () {
    return await ServiceRequestRepository.loadHistoryForm()
  }

  async loadHistoryData (clientDocument) {
    return await ServiceRequestRepository.loadHistoryData(clientDocument)
  }

  routerConsumerUnit (params, protocol, consumerUnit) {
    this.state.serviceRequests[protocol].consumerUnit = consumerUnit
    this.state.serviceRequests[protocol].consumerUnits[consumerUnit].router = params
    this.router(params)
  }
}
